import { render, staticRenderFns } from "./BaseMediaRow.vue?vue&type=template&id=39e569a8&"
import script from "./BaseMediaRow.vue?vue&type=script&lang=js&"
export * from "./BaseMediaRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports